"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_END_USER_ACTION = exports.RECEIVE_END_USER_UPDATE = exports.UNBAN_CANCEL = exports.UNBAN_FAIL = exports.UNBAN_SUCCESS = exports.UNBAN_REQUEST = exports.BAN_CANCEL = exports.BAN_FAIL = exports.BAN_SUCCESS = exports.BAN_REQUEST = exports.FETCH_BANS_CANCEL = exports.FETCH_BANS_FAIL = exports.FETCH_BANS_SUCCESS = exports.FETCH_BANS_REQUEST = exports.FETCH_LASTVIEWED_CANCEL = exports.FETCH_LASTVIEWED_FAIL = exports.FETCH_LASTVIEWED_SUCCESS = exports.FETCH_LASTVIEWED_REQUEST = exports.RECIEVE_USER_FINISHED_TYPING = exports.RECIEVE_USER_STARTED_TYPING = exports.UPDATE_CQL_CANCEL = exports.UPDATE_CQL_FAIL = exports.UPDATE_CQL_SUCCESS = exports.UPDATE_CQL_REQUEST = exports.REMOVE_OLD_PRESENCE_RECORDS = exports.UPDATE_PRESENCE = exports.RECEIVE_PING_PONG_END_USER_PRESENCE = exports.FETCH_ENDUSERS_CANCEL = exports.FETCH_ENDUSERS_FAIL = exports.FETCH_ENDUSERS_SUCCESS = exports.FETCH_ENDUSERS_REQUEST = void 0;
exports.FETCH_ENDUSERS_REQUEST = '@endUsers/FETCH_ENDUSERS_REQUEST';
exports.FETCH_ENDUSERS_SUCCESS = '@endUsers/FETCH_ENDUSERS_SUCCESS';
exports.FETCH_ENDUSERS_FAIL = '@endUsers/FETCH_ENDUSERS_FAIL';
exports.FETCH_ENDUSERS_CANCEL = '@endUsers/FETCH_ENDUSERS_CANCEL';
exports.RECEIVE_PING_PONG_END_USER_PRESENCE = '@endUsers/RECEIVE_PING_PONG_END_USER_PRESENCE';
exports.UPDATE_PRESENCE = '@endUsers/UPDATE_PRESENCE';
exports.REMOVE_OLD_PRESENCE_RECORDS = '@endUsers/REMOVE_OLD_PRESENCE_RECORDS';
exports.UPDATE_CQL_REQUEST = '@endUsers/UPDATE_CQL_REQUEST';
exports.UPDATE_CQL_SUCCESS = '@endUsers/UPDATE_CQL_SUCCESS';
exports.UPDATE_CQL_FAIL = '@endUsers/UPDATE_CQL_FAIL';
exports.UPDATE_CQL_CANCEL = '@endUsers/UPDATE_CQL_CANCEL';
exports.RECIEVE_USER_STARTED_TYPING = '@endUsers/RECIEVE_USER_STARTED_TYPING';
exports.RECIEVE_USER_FINISHED_TYPING = '@endUsers/RECIEVE_USER_FINISHED_TYPING';
exports.FETCH_LASTVIEWED_REQUEST = '@endUsers/FETCH_LASTVIEWED_REQUEST';
exports.FETCH_LASTVIEWED_SUCCESS = '@endUsers/FETCH_LASTVIEWED_SUCCESS';
exports.FETCH_LASTVIEWED_FAIL = '@endUsers/FETCH_LASTVIEWED_FAIL';
exports.FETCH_LASTVIEWED_CANCEL = '@endUsers/FETCH_LASTVIEWED_CANCEL';
exports.FETCH_BANS_REQUEST = '@endUsers/FETCH_BANS_REQUEST';
exports.FETCH_BANS_SUCCESS = '@endUsers/FETCH_BANS_SUCCESS';
exports.FETCH_BANS_FAIL = '@endUsers/FETCH_BANS_FAIL';
exports.FETCH_BANS_CANCEL = '@endUsers/FETCH_BANS_CANCEL';
exports.BAN_REQUEST = '@endUsers/BAN_REQUEST';
exports.BAN_SUCCESS = '@endUsers/BAN_SUCCESS';
exports.BAN_FAIL = '@endUsers/BAN_FAIL';
exports.BAN_CANCEL = '@endUsers/BAN_CANCEL';
exports.UNBAN_REQUEST = '@endUsers/UNBAN_REQUEST';
exports.UNBAN_SUCCESS = '@endUsers/UNBAN_SUCCESS';
exports.UNBAN_FAIL = '@endUsers/UNBAN_FAIL';
exports.UNBAN_CANCEL = '@endUsers/UNBAN_CANCEL';
exports.RECEIVE_END_USER_UPDATE = '@endUsers/RECEIVE_END_USER_UPDATE';
exports.FETCH_END_USER_ACTION = '@endUsers/FETCH_END_USER_ACTION';